/**
 * Which device types actually hold a person's credential.
 *
 * This started as a DENYLIST — "anything except camera / qr_scanner / sensor / guarita /
 * alphadigi_lpr" — which opted every FUTURE device type in by default. A passive device
 * added tomorrow would show up in Dispositivos de Acesso as though it should carry a
 * credential, and back when that section still synced, it would have been written to.
 *
 * Inverted: a device earns its place here by being listed. Unknown means no.
 */
const CREDENTIAL_CAPABLE_DEVICE_TYPES = new Set([
  // Facial. `facial_reader` is models.DeviceTypeFacialReader — the value BOTH device
  // registration forms write and what practically every reader in the field carries. It
  // was missing, so for a customer whose readers are typed that way (all of them) this
  // section filtered everything out and unmounted itself: no device list, anywhere.
  'facial_reader',
  'facial_recognition',
  'hikvision_face',
  'controlid_face',
  'controlid_idflex',
  // Cards / tags
  'rfid_reader',
  'controlid_rfid',
  'card_reader',
  // Biometria — the field carries bare `fingerprint`, condo-manager writes
  // `fingerprint_scanner` (see utils/terminology's note on the same split).
  'fingerprint',
  'fingerprint_scanner',
  'biometric',
  'biometric_reader',
  // Access controllers hold the person records for the readers wired to them.
  'access_controller',
  'controller',
]);

/** True when a person can be enrolled onto this kind of device. */
export function holdsPersonCredential(deviceType?: string | null): boolean {
  return CREDENTIAL_CAPABLE_DEVICE_TYPES.has((deviceType || '').trim().toLowerCase());
}
